module.exports = __webpack_public_path__ + "img/step2.8ecb17ea.png";